import {
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Divider,
  Grid,
  TextField,
  MenuItem,
  List,
  ListItem,
  ListItemText,
  Typography
} from '@material-ui/core';
import { green } from '@material-ui/core/colors';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import Alert from 'src/components/Alert';
import Moment from 'moment';
import { Scrollbars } from 'react-custom-scrollbars';
const useStyles = makeStyles(theme => ({
  root: {
    color: 'white'
  },
  buttonSuccess: {
    position: 'relative',
    float: 'right',
    marginBottom: 10,
    marginLeft: 'auto',
    color: 'white',
    backgroundColor: '#1D3343',
    '&:hover': {
      backgroundColor: '#2f5f82'
    }
  },
  content: {
    minHeight: 130,
    minWidth: 530
  },
  wrapper: {
    '& > div:not(:last-child)': {
      marginBottom: 16
    },
    position: 'relative'
  }
}));

function ItemInfo({ className, ReceiptNo, readonly, tasks }) {
  const classes = useStyles();
  const { t } = useTranslation('work_order');
  const SessionUser = getUser();
  const [loading, setLoading] = useState(false);
  const [SKU, setSKU] = useState('');
  const [ProductSKU, setProductSKU] = useState('');
  const [ProductYear, setProductYear] = useState('');
  const [ProductMonth, setProductMonth] = useState('');
  const [SerialNumber, setSerialNumber] = useState('');
  const [IssueNote, setIssueNote] = useState('');
  const [ReceiptNote, setReceiptNote] = useState('');
  const [NewWorkOrder, setNewWorkOrder] = useState(0);
  const [notePopUp, setNotePopup] = useState(false);
  const [uyariCiktiNote, setUyariCiktiNote] = useState(false);
  const [uyariAciklamaNote, setUyariAciklamaNote] = useState('');
  const [Required, setRequired] = React.useState(false);
  const [uyariTipCiktiNote, setUyariTipCiktiNote] = useState();
  const today = new Date();
  const YazdirMerkezeGonderData = tasks.tasks.filter(
    d => parseInt(d.ReceiptNo) === parseInt(ReceiptNo)
  );
  const [brand, setBrand] = useState(0);
  const [allBrand, setAllBrand] = useState([]);
  const [hierarchy, setHierarchy] = useState(0);
  const [allHierarchy, setAllHierarchy] = useState([]);
  const [aciklama, setAciklama] = useState('');
  const [ContextDetail, setContextDetail] = React.useState([]);
  const [uyariAciklama, setUyariAciklama] = useState('');
  const [uyariTip, setUyariTip] = useState('success');
  const [uyariOpen, setUyariOpen] = useState(false);
  const search = '';
  const confirmOkey = msg => {
    confirmAlert({
      message: msg,
      buttons: [
        {
          label: t('Tamam'),
          onClick: () => {}
        }
      ]
    });
  };
  Moment.locale(SessionUser.TenantCode === 'my' ? 'en' : SessionUser.TenantCode);
  useEffect(() => {
    setBrand();
  }, []);

  const sendSubstitutionYes = (
    SKU,
    ProductYear,
    ProductMonth,
    SerialNumber,
    IssueNote
  ) => {
    if (
      SKU.length <= 0 ||
      //ProductYear.toString().length <= 0 ||
      //ProductMonth.toString().length <= 0 ||
      //SerialNumber.length <= 0 ||
      IssueNote.length <= 0
    ) {
      setRequired(true);
    }

    else {
      if (ProductYear == '') {
        ProductYear = 0;
      }
      if (ProductMonth == '') {
        ProductMonth = 0;
      }
      const data = {
        SKU,
        ProductYear: parseInt(ProductYear),
        ProductMonth: parseInt(ProductMonth),
        SerialNumber,
        IssueNote,
        WorkOrderId: parseInt(YazdirMerkezeGonderData[0].ReceiptNo) || 0,
        WorkCaseId: parseInt(YazdirMerkezeGonderData[0].WorkCaseId) || 0,
        EmployeeId: parseInt(YazdirMerkezeGonderData[0].EmployeeId) || 0,
        Notes: YazdirMerkezeGonderData[0].Notes || '',
        UpdateUserId: parseInt(SessionUser.TechnicianId) || 0
      };
      const config = {
        headers: { 'Content-Type': 'application/json' }
      };
      setLoading(true);
      axios
        .post('SetLoanProduct', data, config)
        .then(response => {
          setNewWorkOrder(response.data[0].WorkOrderIdNew);
          setUyariAciklamaNote(
            response.data[0].WorkOrderIdNew + ' - ' + t('lblSubstitutionMessage')
          );
          setUyariTipCiktiNote('success');
          setUyariCiktiNote(true);
          setNotePopup(false);
          setLoading(false);
        })
        .catch(error => {
          confirmOkey(error.message);
          setNotePopup(false);
          setLoading(false);
        });
    }
  };

  const sendSubstitutionYesForReceipt = (
    ReceiptNote
  ) => {
    if (
      ReceiptNote.length <= 0
    ) {
      setRequired(true);
    } else {
      const data = {
        ReceiptNote,
        WorkOrderId: parseInt(YazdirMerkezeGonderData[0].ReceiptNo) || 0,
        WorkCaseId: parseInt(YazdirMerkezeGonderData[0].WorkCaseId) || 0,
        EmployeeId: parseInt(YazdirMerkezeGonderData[0].EmployeeId) || 0,
        Notes: YazdirMerkezeGonderData[0].Notes || '',
        UpdateUserId: parseInt(SessionUser.TechnicianId) || 0
      };
      const config = {
        headers: { 'Content-Type': 'application/json' }
      };
      setLoading(true);
      axios
        .post('SetLoanProductForUpdate', data, config)
        .then(response => {
          setNewWorkOrder(response.data[0].WorkOrderIdNew);
          setUyariAciklamaNote(
            response.data[0].WorkOrderIdNew + ' - ' + t('lblSubstitutionMessage')
          );
          setUyariTipCiktiNote('success');
          setUyariCiktiNote(true);
          setNotePopup(false);
          setLoading(false);
        })
        .catch(error => {
          confirmOkey(error.message);
          setNotePopup(false);
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    GetTechnicianItemBrand();
    GetProductHiearchy();
    GetItemInfo();
  }, []);



  const setProduct = param => {
    setSKU(param.ModelCode);
    setProductSKU(param.Dsc);
  };

  const uyariKapatCiktiNote = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyariCiktiNote(false);
  };
  const handleChangeBrand = value => {
    setBrand(value);
  };
  const GetTechnicianItemBrand = () => {
    axios.get('/GetTechnicianItemBrand')
      .then((response) => {
        if (response.data.length > 0) {
          setAllBrand(response.data);
        }
      })
      .catch((error) => {

      });
  };
    const handleChangeHierarchy = value => {
    setHierarchy(value);
  };
  const GetProductHiearchy = () => {
    axios.get('/GetProductHiearchy')
      .then((response) => {
        if (response.data.length > 0) {
          setAllHierarchy(response.data);
        }
      })
      .catch((error) => {

      });
  };
  const GetItemInfo = () => {
      setLoading(true);
      const jql = ReceiptNo;
      axios
        .get(`/GetItemInfo/${jql}`)
        .then(response => {
          const Deger = response.data;
          if (Deger.length === 0) {
            setContextDetail([]);
          } else {
            setContextDetail(Deger);
          }
          setLoading(false);
        })
        .catch(error => {
          setContextDetail([]);
          setLoading(false);
        });
    };

  const handleGonder = () => {
    if (brand === 0) {
      setUyariAciklamaNote('lblSelectBrand');
      setUyariTipCiktiNote('error');
      setUyariCiktiNote(true);
      return;
    }
    if (hierarchy === 0) {
      setUyariAciklamaNote('lblSelectHierarchy');
      setUyariTipCiktiNote('error');
      setUyariCiktiNote(true);
      return;
    }
    let body = {
        Id: 0,
        BrandId: brand,
        Dsc:aciklama,
        HierarchyId:hierarchy,
        WorkOrderId:parseInt(YazdirMerkezeGonderData[0].ReceiptNo) || 0
        }
      const config = {
        headers: { 'Content-Type': 'application/json' }
      };
  
      axios
        .post('/SetItemInfo', body, config)
        .then(response => {
          if (
            response.data !== ''
          ) {
             setUyariAciklamaNote(response.data[0].ErrorDescription
          );
          setUyariTipCiktiNote('success');
          setUyariCiktiNote(true);
            setAciklama('');
            setBrand(0);
            setHierarchy(0);
          } else {
            showAlert('error', t('Error') + (response.data[0]?.errorMessage || ''));
          }
          GetItemInfo();
          setLoading(false);
        })
        .catch(error => {
          showAlert('error', t('Error'));
          setLoading(false);
        });

  const showAlert = (tip, msg) => {
    setUyariAciklama(msg);
    setUyariTip(tip);
    setUyariOpen(true);
  };
  }
  
    return (
  <Card className={clsx(classes.cards, className)}>
    <CardHeader title={t('lblAddItemInfo')} />
    {uyariCiktiNote ? (
      <Alert
        onClose={uyariKapatCiktiNote}
        open={uyariCiktiNote}
        message={uyariAciklamaNote || ''}
        variant={uyariTipCiktiNote}
      />
    ) : null}
    <Divider />
    <CardContent className={classes.cardscontent}>
      {loading && (
        <CircularProgress status="loading" style={{ marginLeft: '50%' }} />
      )}
      
      <div className={classes.wrapper}>
        <Grid container spacing={2}> 
          <Grid item xs={12}>
            <TextField
              size="small"
              fullWidth
              select
              value={brand}
              onChange={e => handleChangeBrand(e.target.value)}
              variant="outlined"
              label={t('lblSelectItemBrand')}
            >
              {allBrand.map(p => (
                <MenuItem key={p.Id} value={p.Id}>
                  {p.Dsc}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12}>
            <TextField
              size="small"
              fullWidth
              select
              value={hierarchy}
              onChange={e => handleChangeHierarchy(e.target.value)}
              variant="outlined"
              label={t('lblSelectHierarchy')}
            >
              {allHierarchy.map(p => (
                <MenuItem key={p.HierarchyId} value={p.HierarchyId}>
                  {p.Desc}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12}>
            <TextField
              label={t('lblItemInfoDescription')}
              multiline
              rows={4}
              fullWidth
              value={aciklama}
              onChange={e => setAciklama(e.target.value)}
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              className={classes.buttonSuccess}
              onClick={handleGonder}
              color="primary"
              variant="contained"
              fullWidth
            >
              {t('lblSave')}
            </Button>
          </Grid>
        </Grid>
      </div>
      
      <br />
      <Divider />
      
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <CardContent className={classes.content} style={{ padding: 0, marginTop: 10 }}>
            <Scrollbars style={{ width: '100%', height: 200 }}>
              <List className={classes.root}>
                {ContextDetail.map((data, index) => (
                  <div key={index}>
                    <ListItem alignItems="flex-start">
                      <ListItemText
                        primary=""
                        secondary={
                          <Typography
                            component="span"
                            variant="body1"
                            className={classes.inline}
                            color="textPrimary"
                          >
                            <b>{t('User')}:</b> {data.Employee}
                            <br />
                            <b>{t('Date')}:</b>{' '}
                            {data.CreateDate === undefined
                              ? ''
                              : Moment(data.CreateDate).format('DD/MM/YYYY HH:mm')}
                            <br />
                            <b>{t('Brand')}:</b> {data.BrandDesc}
                            <br />
                            <b>{t('Hierarchy')}:</b> {data.ProductHierarchy}
                            <br />
                            <b>{t('Description')}:</b> {data.Dsc}
                            <br />
                          </Typography>
                        }
                      />
                    </ListItem>
                    <Divider component="li" />
                  </div>
                ))}
              </List>
            </Scrollbars>
          </CardContent>
        </Grid>
      </Grid>
    </CardContent>
  </Card>
);
  
}

ItemInfo.propTypes = {
  className: PropTypes.string
};

export default connect(state => ({ tasks: state.tasks1 }))(ItemInfo);
